export const ORGANIZATIONS = (id?: string) => {
  if (id) {
    return `base/organizations/${id}`;
  }
  return `base/user/organizations`;
};

export const GET_ORGANISATION_TYPES = 'base/organization-types';

export const FETCH_USER_ENDPOINT = `base/user`;
export const EDIT_USER_ENDPOINT = (user_id: string) => `base/users/${user_id}`;
export const SETUP_GOOGLE2FA_ENDPOINT = (user_id: string) =>
  `base/users/${user_id}/setup-googleTfa`;
